import { render, staticRenderFns } from "./KD3Config.vue?vue&type=template&id=985327ba&scoped=true"
import script from "./KD3Config.vue?vue&type=script&lang=js"
export * from "./KD3Config.vue?vue&type=script&lang=js"
import style0 from "./KD3Config.vue?vue&type=style&index=0&id=985327ba&prod&lang=css"
import style1 from "./KD3Config.vue?vue&type=style&index=1&id=985327ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985327ba",
  null
  
)

export default component.exports